import * as React from "react";

export const ClearFilterGrid = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="#333333"
      d="M8.333 15h2.043v-1.667H8.333V15ZM2.5 5v1.667h15V5h-15ZM5 10.833h5.376V9.167H5v1.666ZM12.2 9.013l-.714.714 1.877 1.876-1.877 1.876.713.714 1.877-1.877 1.876 1.877.714-.714-1.877-1.876 1.877-1.876-.714-.714-1.876 1.877-1.877-1.877Z"
    />
  </svg>
);
